import { render, staticRenderFns } from "./mapDragPoint.vue?vue&type=template&id=dd7060de&scoped=true&"
import script from "./mapDragPoint.vue?vue&type=script&lang=js&"
export * from "./mapDragPoint.vue?vue&type=script&lang=js&"
import style0 from "./mapDragPoint.vue?vue&type=style&index=0&id=dd7060de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7060de",
  null
  
)

export default component.exports